__turbopack_context__.v({
  "Actions": "kR7DBa_Actions",
  "AppendingText": "kR7DBa_AppendingText",
  "BenefitContainer": "kR7DBa_BenefitContainer",
  "CouponContainer": "kR7DBa_CouponContainer",
  "CouponLabel": "kR7DBa_CouponLabel",
  "CouponText": "kR7DBa_CouponText",
  "Headline": "kR7DBa_Headline",
  "InnerContainer": "kR7DBa_InnerContainer",
  "Left": "kR7DBa_Left",
  "LeftLabel": "kR7DBa_LeftLabel",
  "RevealContainer": "kR7DBa_RevealContainer",
  "Right": "kR7DBa_Right",
  "Vertical": "kR7DBa_Vertical",
  "ZoomContainer": "kR7DBa_ZoomContainer",
  "code-revealer-skeleton-pulse": "kR7DBa_code-revealer-skeleton-pulse",
  "codeSkeleton": "kR7DBa_codeSkeleton",
});
